import React, { Component } from 'react';
import i18n from 'i18n-react';

import clsx from 'clsx';
import ReactTooltip from 'react-tooltip';
import { capitalize } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';
import { renderToString } from 'react-dom/server';
import { primaryColor } from 'config/styles.json';

import {rewardsProgramParticipants} from 'settings';

import {
  APIHandler,
  Diploma,
  DataHandler,
  PointsDisplay,
  PointsAlert,
  PointsHandler,
  StorageHandler,
  SubAppButton,
  SweetAlert,
  TrainingCard,
  Progress,
} from 'C4';
import { baseAppId, storageKeys, points, imgixUrl } from 'settings';

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';

import badgeBronze from 'assets/images/bronze_badge.png';
import badgeGold from 'assets/images/golden_badge.png';
import badgeSilver from 'assets/images/silver_badge.png';
import badges from 'assets/images/badges';

import BadgeDisplay from 'components/BadgeDisplay/BadgeDisplay';

const sendBronzeMail = async () => {
  const appId = await DataHandler.matchAppId();

  if (appId === 808) {
    const user = (await StorageHandler.load(storageKeys.user)) || {};
    if (user) {
      const { email } = user;
      await APIHandler.updateUser('caDeBronze', email, [{ param: 'sales_companion_registered', val: Date.now() }]);
    }
  }
};

// helper to parse an i18n translate string based on a config array that checks if
const i18nParsedTranslate = (string, country) => {
  const hasLinkedAlternative = ['popUp.platinum'];

  // if the translation does NOT have an alternative link, or the user is NOT in the US, return the translation as it is
  if (!(hasLinkedAlternative.includes(string) && rewardsProgramParticipants.includes(country))) {
    return i18n.translate(string);
  }

  return (
    <div className="trainingGrid__sweetAlertTextBox">
      <a href="/main/rewards/achievements">
        <h3>{i18n.translate('popUp.congratulations')}</h3>
        {i18n.translate(`${string}WithLink.start`)} {i18n.translate(`${string}WithLink.link`)}{' '}
        {i18n.translate(`${string}WithLink.end`)}
      </a>
    </div>
  );
};

const SubProgressBar = ({ type, progress }) => {
  // Send email if first four chapters are completed
  // if (type === 'bronze' && progress >= 100) {
  //   sendBronzeMail();
  // }

  return (
    <div className={`subprogress ${type}`}>
      <Progress id="subprogress" value={progress} rounded={true} />
      <p>
        {progress} {i18n.translate('trainingScreens.percentageComplete')}
      </p>
    </div>
  );
};

export default class TrainingGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appId: 0,
      app: {},
      chapters: [],
      chaptersSub: [],
      chapters_progress: [],
      pdfShown: true,
      subApps: [],
      swal: [],
      swalOpen: false,
      diploma: 0,
      completedSubApps: [],
      totalItemCount: 0,
      totalItemCountCompleted: 0,
      userCountry: '',
      countryName: '',
      progressSubApps: 0,
      progressMain: 0,
      progressSub: 0,
      badgeAlert: 0,
      refresh: false,
    };

    this.isLocked = this.isLocked.bind(this);
    this.loadChapters = this.loadChapters.bind(this);
    this.calculateProgress = this.calculateProgress.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    this.mountedApp = true;
    this.getProgress();
  }

  componentWillUnmount() {
    this.mounted = false;
    this.mountedApp = false;
  }

  async getProgress() {
    StorageHandler.load(storageKeys.lang).then((lang) => {
      this.setState({ userCountry: lang.code, countryName: lang.country });
    });

    const user = await StorageHandler.load(storageKeys.user);
    if (user) {
      const { email } = user;
      const { appId } = window;
      if (this.mountedApp) {
        this.mountedApp = false;
        this.setState({ appId });
        const userProgress = await APIHandler.getUserProgress(appId, email);
        await this.calculateProgress(userProgress);
      }
    }
  }

  getTieredValue(array = null) {
    const { tiers, totalPoints } = this.pointsHandler;

    let index = 0;
    tiers.forEach(({ points: tierPoints }, i) => {
      // Could be improved, maybe using filter / reduce?
      if (totalPoints >= tierPoints) {
        index = i;
      }
    });

    if (array) return array[index < 0 ? 0 : index];
    return index;
  }

  async getSubAppProgress(appIds) {
    const user = await StorageHandler.load(storageKeys.user);
    if (user) {
      const { email } = user;
      if (this.mounted && appIds.length > 0) {
        const { data } = await APIHandler.getUserProgress(appIds, email);
        return (
          (data &&
            Object.values(data).map(
              ({ chapters: [chapter], name, region_hidden, general_background_image, app_id, coming_soon }) => ({
                chapter,
                name,
                region: region_hidden,
                chapterImage: general_background_image,
                app_id,
                comingSoon: Boolean(coming_soon),
              }),
            )) ||
          []
        );
      }
    }
    return null;
  }

  async setSubApps(appId) {
    const { userCountry, chapters_progress } = this.state;
    const user = await StorageHandler.load(storageKeys.user);
    if (user) {
      const { email } = user;

      const ids = await APIHandler.getSubApps(appId);
      ids.sort((a, b) => {
        return a.number - b.number;
      });

      const appIds = ids.map(({ sessions }) =>
        sessions.map(function (item) {
          return item['session_app_id'];
        }),
      );
      const allAppIds = appIds.flat();

      const progress = await this.getSubAppProgress(allAppIds);
      const subAppPromises = appIds.map(async (id) => {
        let provinceWithCitys = progress.filter(({ app_id }) => id.map((app) => app.toString()).includes(app_id));
        const {
          chapter,
          name,
          region,
          chapter: { last_page: lastPage, total_pages: totalPages, chapter: chapterID },
          chapterImage,
          comingSoon,
        } = provinceWithCitys[0];

        const pageId = lastPage < totalPages ? lastPage : 0;

        if (region === 1 && (userCountry === 'caEn' || userCountry === 'caFr' || userCountry === 'CA')) {
          return;
        }

        let maxCount = 9;
        if (userCountry === 'caEn' || userCountry === 'caFr' || userCountry === 'CA') {
          maxCount = 8;
        }

        // makes an array that contains the right information for the citys that belong to the province
        const citys = provinceWithCitys.slice(1);
        const ids = id;

        const getCityInfo = citys.map(async (city, i) => {
          if (city.chapter === undefined) {
            city.chapter = { last_page: 0, total_pages: 0, chapter: 0 };
          }

          const {
            chapter,
            name,
            comingSoon,
            chapter: { last_page: lastPage, total_pages: totalPages, chapter: chapterID },
          } = city;

          const pageId = lastPage < totalPages ? lastPage : 0;
          const cityIDs = ids.slice(1);
          let percentage = Math.round((chapter.progress / chapter.total_pages) * 100);
          if (percentage >= 100) {
            percentage = 100;
          }

          const info = {
            chapter: chapter,
            chapterID: chapterID,
            name: name,
            pageId: pageId,
            appId: cityIDs[i],
            percentage: percentage,
            comingSoon: comingSoon,
          };
          return info;
        });

        const cityInfo = await Promise.all(getCityInfo).then(function (results) {
          return results;
        });

        return (
          <SubAppButton
            key={chapterID}
            appId={id[0]}
            progress={chapter}
            name={name}
            pageId={pageId}
            size={{ height: 100, width: 100 }}
            type="training"
            email={email}
            chapterId={chapterID}
            backgroundImage={chapterImage}
            citys={cityInfo}
            comingSoon={comingSoon}
            locked={
              Boolean(chapters_progress[maxCount].percentage < 95) ||
              chapters_progress[maxCount].percentage === undefined
            }
          />
        );
      });
      if (this.mounted) {
        const subApps = await Promise.all(subAppPromises);

        const completedSubApps = progress
          .filter(
            ({ chapter: { progress: subProgress, total_pages: totalPages } }) =>
              Math.floor(subProgress / totalPages) * 100 >= 100,
          )

          .map(({ chapter }) => chapter);

        this.setState({ subApps, completedSubApps });
      }
      return null;
    }

    this.setState({ subApps: [] });
    return null;
  }

  async handlePoints() {
    const { chapters_progress: progress, chapters, subApps, completedSubApps, swal, userCountry, countryName, appId } = this.state;
    const { introChapters } = points;

    let count = 4;
    if (userCountry === 'caFr') {
      count = 3;
    }
    if (userCountry === 'caEn') {
      count = 3;
    }
    if (userCountry === 'CA') {
      count = 3;
    }


    const intro = progress
      .filter((chapter, i) =>
        introChapters // Filter progress to just the introChapters
          .some((val) => +new RegExp('(.*?-)*(?<index>[0-9]+)', 'g').exec(val).groups.index === i + 1),
      )
      .filter(({ percentage }) => percentage && percentage >= 100);

    const rest = progress
      .filter((chapter, i) =>
        introChapters // Filter introChapters
          .every((val) => +new RegExp('(.*?-)*(?<index>[0-9]+)', 'g').exec(val).groups.index !== i + 1),
      )
      .filter(({ percentage }) => percentage && percentage >= 100);

    if (chapters && this.pointsHandler.tiers) {
      const introsComplete = intro.map(({ chapter }) => this.updatePoints('intro-chapter', chapter));
      const chaptersComplete = rest.map(({ chapter }) => this.updatePoints('chapter', chapter));
      const subAppsComplete = completedSubApps.map(({ chapter }) => this.updatePoints('subapp', chapter));

      // Calculate percentage of intro complete completed chapters
      const totalCh = progress.slice(0);
      const totalChCopy = progress.slice(0);
      const introCh = totalCh.splice(0, count);
      const subCh = totalChCopy.splice(count, totalChCopy.length);

      const subAppCityLengt = subApps.map(({ props }) => props.citys.length).reduce((app, app1) => app + app1);

      const introProgress = introCh.filter(({ percentage }) => percentage && percentage >= 100);
      const restProgress = subCh.filter(({ percentage }) => percentage && percentage >= 100);

      const introPercentage = Math.floor((introProgress.length / introCh.length) * 100);
      const chaptersPercentage = Math.floor((restProgress.length / subCh.length) * 100);
      const subAppsPercentage = Math.floor((completedSubApps.length / 10) * 100);

      this.setState({
        progressMain: introPercentage,
        progressSub: chaptersPercentage,
        progressSubApps: subAppsPercentage,
      });

      const allUpdates = await Promise.all([introsComplete, chaptersComplete, subAppsComplete].flat());
      const totalPointsGained = [...allUpdates.map(({ points: p }) => p), 0].reduce(
        (total, pointsGained) => total + pointsGained,
      );

      if (!Number.isNaN(totalPointsGained) && totalPointsGained > 0) {
        const [{ points: firstPoints }] = allUpdates.filter(({ points: p }) => p > 0);
        const { tiers, totalPoints } = this.pointsHandler;
        const badgeURl = [];
        let popUp = '';
        const tierIndex = tiers && Math.min(this.getTieredValue(), tiers.length - 1);
        const { tierBadges } = badges;

        if (totalPoints === tiers[tierIndex].points) {
          badgeURl.push(Object.values(tierBadges)[tierIndex]);
        } else {
          badgeURl.push(Object.values(tierBadges)[tierIndex]);
          return;
        }

        const user = await StorageHandler.load(storageKeys.user);
        if (tierIndex === 0) {
          popUp = 'bronze';
        } else if (tierIndex === 1) {
          popUp = 'silver';
          if (user) {
            await APIHandler.sendEmail(popUp, appId, user.email, user.first_name, user.last_name);
          }
        } else if (tierIndex === 2) {
          popUp = 'gold';
          if (user) {
            await APIHandler.sendEmail(popUp, appId, user.email, user.first_name, user.last_name);
          }
        } else if (tierIndex === 3) {
          popUp = 'platinum';
          if (user) {
            await APIHandler.sendEmail(popUp, appId, user.email, user.first_name, user.last_name);
          }
        }

        const newSwal = [...swal];
        newSwal.push({
          imageUrl: badgeURl,
          imageWidth: 110,
          imageAlt: `+${firstPoints}XP`,
          showCloseButton: true,
          showConfirmButton: false,
          confirmButtonText: popUp === 'silver' ? i18n.translate('nav.reportCard') : 'close',
          icon: '',
          customClass: {
            closeButton: 'trainingGrid__swal2-close',
          },
          html: renderToString(
            <React.Fragment>
              <p>{i18nParsedTranslate(`popUp.${popUp}`, countryName)}</p>
              <PointsAlert
                key={JSON.stringify(points)}
                tiers={tiers}
                points={totalPoints}
                pointsGained={totalPointsGained}
                delay={750}
              />
            </React.Fragment>,
          ),
          onClose: () => {
            if (popUp === 'silver') {
              document.getElementById('showDiplomaButton').click();
            }
            this.setState(
              ({ swal: swalState }) => ({ swalOpen: false, swal: swalState.slice(1) }),
              () => {
                const { swal: swalState } = this.state;
                if (swalState.slice(1).length > 0) {
                  this.setState({ swalOpen: true });
                }
              },
            );
          },
          ...(popUp === 'platinum' ? { background: primaryColor } : {}),
        });

        if (totalPoints === tiers[tierIndex].points) {
          this.setState({ swal: newSwal, swalOpen: true });
        }
      }

      const allItemsCompleted = [introsComplete.length, chaptersComplete.length, subAppsComplete.length];
      const allItems = [progress.length, subApps.length, subAppCityLengt];

      const totalItemCountCompleted = allItemsCompleted.reduce((total, len) => total + len);
      const totalItemCount = allItems.reduce((total, len) => total + len);

      this.setState({ totalItemCountCompleted, totalItemCount });
    }
  }

  async updatePoints(action, i) {
    const { totalPoints, tiers } = this.pointsHandler;
    const { points: maxedPoints } = tiers[tiers.length - 1];
    const userIsMaxed = totalPoints >= maxedPoints;

    if (!userIsMaxed) {
      const { response } = await this.pointsHandler.setPoints({
        action,
        value: `${action}-${i}`,
      });
      if (response !== 'Already used') {
        const { update } = response;
        this.setState({ refresh: true });
        return update;
      }
    }
    return { points: 0 };
  }

  async initPointsHandler() {
    this.pointsHandler = new PointsHandler();
    await this.pointsHandler.init();
    await this.pointsHandler.getPoints();
  }

  async loadChapters(setProgress) {
    const { appId, userCountry } = this.state;

    const { app } = await APIHandler.getChapters(appId);
    this.setState({ app: app });

    if (!setProgress) {
      const user = await StorageHandler.load(storageKeys.user);
      const registered = await APIHandler.registerUserProgress(user.email);

      // TODO refresh, if status is 201
      if (registered) {
        window.location.reload();
      }
    } else {
      const { chapters_progress: chaptersProgress } = this.state;
      let count = 4;
      if (userCountry === 'caFr') {
        count = 3;
        chaptersProgress.splice(3, 1);
      }
      if (userCountry === 'CA') {
        count = 3;
        chaptersProgress.splice(3, 1);
      }
      if (userCountry === 'caEn') {
        count = 3;
        chaptersProgress.splice(3, 1);
      }

      const chapters = app.splice(0, count).map((chapter, i) => (
        <React.Fragment key={chapter.chapterID}>
          <div key={chapter.chapterID} className="trainingCard__Animated">
            <TrainingCard
              chaptersProgress={chaptersProgress[i]}
              chapter={chapter}
              chapterCount={chapter.chapterItemCount}
              locked={this.isLocked(i)}
              index={i}
              appId={appId}
              key={chapter.chapterID}
            />
          </div>
        </React.Fragment>
      ));

      // Remove one chapter for Canada
      if (userCountry === 'caFr') {
        app.splice(0, 1);
      }
      if (userCountry === 'caEn') {
        app.splice(0, 1);
      }
      if (userCountry === 'CA') {
        app.splice(0, 1);
      }

      const chaptersSub = app.map((chapter, i) => (
        <React.Fragment key={chapter.chapterID}>
          <div key={chapter.chapterID} className="trainingCard__Animated specialization">
            <TrainingCard
              chaptersProgress={chaptersProgress[count + i]}
              chapter={chapter}
              chapterCount={chapter.chapterItemCount}
              locked={this.isLocked(i, true)}
              index={i}
              appId={appId}
              key={chapter.chapterID}
            />
          </div>
        </React.Fragment>
      ));

      this.setState({ chapters, chaptersSub }, async () => {
        await this.initPointsHandler();
        await this.setSubApps(appId);
        await this.handlePoints();
      });
    }
  }

  calculateProgress(res) {
    if (res.status !== 'error') {
      const { chapters } = res.data[0];
      chapters.forEach((chapter) => {
        const newChapter = chapter;
        if (chapter.progress > 0 && chapter.total_pages > 0) {
          newChapter.percentage = ((chapter.progress + 1) / chapter.total_pages) * 100;
          if (newChapter.percentage > 100) {
            newChapter.percentage = 100;
          }
        }
      });

      this.setState({ chapters_progress: chapters }, () => {
        this.loadChapters(res.status !== 'error');
      });
    } else {
      this.loadChapters(res.status !== 'error');
    }
  }

  isLocked(key, sub = false) {
    const { chapters_progress: progress, userCountry } = this.state;

    // After first four chapters all should be unlocked
    if (userCountry === 'caFr' || userCountry === 'caEn' || userCountry === 'CA') {
      if (progress.length > 0 && sub === true && progress[2].percentage !== 100) {
        return true;
      }

      if (progress.length > 0 && sub === true && progress[2].percentage === 100) {
        return false;
      }
    } else {
      if (progress.length > 0 && sub === true && progress[3].percentage !== 100) {
        return true;
      }

      if (progress.length > 0 && sub === true && progress[3].percentage === 100) {
        return false;
      }
    }

    // First four chapters in orders
    if (progress.length > 0 && key === 0) {
      return false;
    }

    if (progress.length > 0 && progress[key - 1].percentage === 100) {
      return false;
    }

    return true;
  }

  render() {
    const {
      chapters,
      chaptersSub,
      subApps,
      app,
      swal,
      swalOpen,
      totalItemCountCompleted,
      totalItemCount,
      progressMain,
      progressSub,
      progressSubApps,
      userCountry,
    } = this.state;

    const { tierBadges } = badges;
    const { initialized, tiers, totalPoints } = this.pointsHandler || {};
    const tierIndex = tiers && Math.min(this.getTieredValue(), tiers.length - 1);

    let bronzeCount = 4;
    if (userCountry === 'caFr' || userCountry === 'caEn' || userCountry === 'CA') {
      bronzeCount = 3;
    }

    let opened = [];
    if (initialized && chapters && app && app.length > 0 && subApps && chaptersSub) {
      if (progressMain < 100) {
        opened.push('main');
      } else if (progressSub < 100) {
        opened.push('sub');
      } else if (progressSubApps < 100) {
        opened.push('mew');
      } else if (progressSubApps >= 100 && progressSub >= 100 && progressMain >= 100) {
        opened.push('mew');
        opened.push('sub');
        opened.push('main');
      }
    }

    return (
      <React.Fragment>
        {swal && swal.length > 0 && tiers && <SweetAlert trigger={swalOpen} {...(Array.isArray(swal) && swal[0])} />}

        {initialized &&
          tiers && ( // Wrap in own component?
            <BadgeDisplay
              tierBadges={tierBadges}
              tierIndex={tierIndex}
              tiers={tiers}
              totalPoints={totalPoints}
              pointsBarSubtitle={i18n.translate('points.completed', {
                completed: totalItemCountCompleted,
                total: totalItemCount,
              })}
              layout="pillar"
              position="right"
            />
          )}
        {chapters && app.length > 0 && subApps && chaptersSub && (
          <Accordion preExpanded={opened} key={opened}>
            <div>
              <div className="trainingGrid">
                <AccordionItem uuid="main">
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <div className="subheader bronzeHeader">
                        <h1>{i18n.translate('trainingScreens.essential')}</h1>
                        <h2>{i18n.translate('trainingScreens.essentialSub')}</h2>
                        <img className="badge" src={badgeBronze} alt="bronze badge" />
                        <SubProgressBar type="bronze" progress={progressMain} />
                        <AccordionItemState>
                          {({ expanded }) =>
                            !expanded ? (
                              <div className="arrow">
                                <FontAwesomeIcon icon={['fas', 'chevron-down']} />
                              </div>
                            ) : (
                              <div className="arrow">
                                <FontAwesomeIcon icon={['fas', 'chevron-up']} />
                              </div>
                            )
                          }
                        </AccordionItemState>
                      </div>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div className="trainingGrid">{chapters}</div>
                  </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem uuid="sub">
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <div className="subheader sub silverHeader">
                        <h1>{i18n.translate('contentHeaders.subtrainings')}</h1>
                        <h2>{i18n.translate('pageDescriptions.subtrainings')}</h2>
                        <img className="badge" src={badgeSilver} alt="silver badge" />
                        <SubProgressBar type="silver" progress={progressSub} />
                        <AccordionItemState>
                          {({ expanded }) =>
                            !expanded ? (
                              <div className="arrow">
                                <FontAwesomeIcon icon={['fas', 'chevron-down']} />
                              </div>
                            ) : (
                              <div className="arrow">
                                <FontAwesomeIcon icon={['fas', 'chevron-up']} />
                              </div>
                            )
                          }
                        </AccordionItemState>
                      </div>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div className="trainingGrid">{chaptersSub}</div>
                  </AccordionItemPanel>
                </AccordionItem>
              </div>
              <AccordionItem uuid="mew">
                <div className="trainingGrid subApps">
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <div className="subheader goldHeader">
                        <h1>{i18n.translate('contentHeaders.subapps')}</h1>
                        <h2>{i18n.translate('pageDescriptions.subapps')}</h2>
                        <img className="badge" src={badgeGold} alt="gold badge" />
                        {/* <SubProgressBar type="gold" progress={progressSubApps} />*/}
                        <AccordionItemState>
                          {({ expanded }) =>
                            !expanded ? (
                              <div className="arrow">
                                <FontAwesomeIcon icon={['fas', 'chevron-down']} />
                              </div>
                            ) : (
                              <div className="arrow">
                                <FontAwesomeIcon icon={['fas', 'chevron-up']} />
                              </div>
                            )
                          }
                        </AccordionItemState>
                      </div>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                </div>
                <AccordionItemPanel>
                  <div className="trainingGrid subApps">{subApps}</div>
                </AccordionItemPanel>
              </AccordionItem>
            </div>
          </Accordion>
        )}
      </React.Fragment>
    );
  }
}
